<template>
  <main class="complete-main">
    <div class="complete-container">
      <h1><img class="logo" src="@/assets/img/login_logo.svg" alt="ディーモ for 社労士" /></h1>
      <div class="message-content">
        <div class="header">
          <p :class="titleClass">{{ title }}</p>
        </div>

        <div class="content-message" v-html="message"></div>

        <div class="action-buttons">
          <button class="input-submit" @click="goToLogin">ログインへ</button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
  export default {
    name: 'EmailChangeResult',
    computed: {
      isSuccess() {
        return this.$route.query.emailChange === 'success'
      },

      title() {
        return this.isSuccess ? 'メールアドレス変更完了' : 'メールアドレス変更エラー'
      },

      message() {
        if (this.isSuccess) {
          return 'メールアドレスが正常に変更されました。<br>新しいメールアドレスに送信された認証メールを確認してください。'
        } else {
          return 'メールアドレスの変更中にエラーが発生しました。<br>再度メール変更をお試しください。'
        }
      },

      iconClass() {
        return this.isSuccess ? 'success-icon' : 'error-icon'
      },

      titleClass() {
        return this.isSuccess ? 'title success' : 'title error'
      },
    },

    methods: {
      goToLogin() {
        this.$router.push('/login')
      },
    },

    mounted() {
      // URLからクエリパラメータをチェック
      if (!this.$route.query.emailChange) {
        // メールアドレス変更関連のパラメータがない場合はトップページにリダイレクト
        this.$router.push('/login')
      }
    },
  }
</script>

<style lang="less" scoped>
  .complete-main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
    color: var(--text-color);
  }

  .complete-container {
    margin: auto;
    width: 100%;
    max-width: 600px;
    background-color: #fff;
    border-radius: 10px;
    padding: 50px 35px;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);

    h1 {
      text-align: center;
      margin-bottom: 2rem;

      .logo {
        width: 100%;
        max-width: 200px;
        height: auto;
      }
    }
  }

  .message-content {
    width: 100%;
    max-width: 600px;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    text-align: center;
  }

  .header {
    margin-bottom: 30px;
  }

  .title {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 20px 0;
  }

  .title.success {
    color: #28a745;
  }

  .title.error {
    color: #dc3545;
  }

  .content-message {
    font-size: 14px;
    margin-bottom: 30px;
    text-align: center;
    line-height: 1.6;
    color: #333;
  }

  .action-buttons {
    width: 80%;
    margin: 0 auto;
    margin-top: 20px;
  }
</style>
